import { useState } from 'react';
import styled from '@emotion/styled';
import { generateLink } from '../value/utilities';
import FilterWrapper from '../value/FilterWrapper';
import TableWrapper from './TableWrapper';
import CsvDownloadButton from '../value/CsvDownloadButton';
import { ContentValueStoryLevelStats, ContentValueTrafficValue } from 'types';
import { US_AND_CANADA, VALID_REGIONS } from '../value/constants';
import useLocalStorage from 'components/hooks/useLocalStorage';
import {
  Modal,
  ModalHeader,
  H2,
  ModalBody,
  P,
  Icon,
  FlexRow,
  Grid,
  BaseCol,
} from 'toolkit/components';

const SpacedRow = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 3.5rem;
`;

interface StoryLevelWrapperProps {
  storyLevelStats: ContentValueStoryLevelStats[];
  avgTrafficValueBySinglePub: ContentValueTrafficValue;
  pubId: string;
}

const StoryLevelWrapper = ({
  storyLevelStats,
  avgTrafficValueBySinglePub,
  pubId,
}: StoryLevelWrapperProps) => {
  const storedRegion = useLocalStorage('contentValueRegion');
  const [filterState, setFilterState] = useState(storedRegion || US_AND_CANADA);
  const [modal, setModal] = useState(false);
  const region = VALID_REGIONS.find((reg) => storedRegion === reg);
  const queryParams = { region };
  const csvLink = generateLink(queryParams, `analytics/${pubId}/value/story_level_csv?`);

  return (
    <>
      <Modal isOpen={modal} onClose={() => setModal(false)}>
        <ModalHeader>
          <H2>Story Content Value</H2>
        </ModalHeader>
        <ModalBody>
          <P>
            This page tracks the Content Value of individual stories. To learn more about the
            metrics that appear on this page, visit{' '}
            <a href="https://contently-support.kayako.com/article/944-understanding-and-improving-your-content-value-dashboard">
              this article
            </a>{' '}
            in Contently&apos;s help center.
          </P>
        </ModalBody>
      </Modal>
      <SpacedRow>
        <H2>
          Story Content Value
          <Icon type="question-circle" onClick={() => setModal(true)} />
        </H2>
        <FlexRow>
          <FilterWrapper filterState={filterState} setFilterState={setFilterState} />
          <CsvDownloadButton csvLink={csvLink} downloadBoxMargin="3.5rem" />
        </FlexRow>
      </SpacedRow>
      <Grid>
        <FlexRow>
          <BaseCol>
            <TableWrapper
              region={filterState}
              tableInfo={storyLevelStats}
              trafficValAvg={avgTrafficValueBySinglePub}
            />
          </BaseCol>
        </FlexRow>
      </Grid>
    </>
  );
};

export default StoryLevelWrapper;
